/**
 * Environment for package-manager child processes, with npm 12's
 * script-approval config stripped.
 *
 * Running under `npx @standardagents/cli@latest init`, the parent npm
 * forwards the user's configuration to child processes as `npm_config_*`
 * environment variables. npm 12 treats an env-layer `allow-scripts` value as
 * a command-line policy and FAILS project-scoped installs with EALLOWSCRIPTS
 * ("--allow-scripts is not allowed in project-scoped installs") even though
 * the user never typed the flag — the value leaked from their user/global
 * .npmrc or the npx invocation (npm/cli#9783). Script approval for generated
 * projects lives in package.json#allowScripts, so the inherited settings are
 * dropped rather than forwarded.
 */
export function packageManagerEnv(base: NodeJS.ProcessEnv = process.env): NodeJS.ProcessEnv {
  const env: NodeJS.ProcessEnv = {};
  for (const [key, value] of Object.entries(base)) {
    const normalized = key.toLowerCase().replace(/-/g, '_');
    if (
      normalized === 'npm_config_allow_scripts' ||
      normalized === 'npm_config_strict_allow_scripts' ||
      normalized === 'npm_config_allow_scripts_pending' ||
      normalized === 'npm_config_allow_scripts_pin'
    ) {
      continue;
    }
    env[key] = value;
  }
  return env;
}
